import { useLocation } from 'react-router-dom'
import {
  NavigationMenu,
  NavigationMenuContent,
  NavigationMenuItem,
  NavigationMenuLink,
  NavigationMenuList,
  NavigationMenuTrigger,
} from '@/components/ui/navigation-menu'
import Logo from '@/components/shared/Logo'
import UtmLink from '@/components/shared/UtmLink'
import CTAButton from '@/components/shared/CTAButton'
import { lendersData, vehicleMakesData } from '@/shared/navigationData'

const DesktopHeader = () => {
  const { pathname } = useLocation()

  const isActive = href => pathname === href
  const isSection = prefix => pathname.startsWith(prefix)

  const navLinkClass = href =>
    [
      'bg-background inline-flex h-9 w-max items-center justify-center rounded-md px-4 py-2 text-base font-semibold transition-colors hover:bg-gray-100 hover:text-[#095678] focus:outline-none focus-visible:ring-2 focus-visible:ring-[#095678] focus-visible:rounded-md',
      isActive(href)
        ? 'text-[#095678] font-bold underline underline-offset-4'
        : '',
    ]
      .filter(Boolean)
      .join(' ')

  return (
    <div className="container mx-auto hidden max-w-[90%] items-center justify-between py-4 lg:flex lg:max-w-[85%] xl:max-w-[80%]">
      <div className="flex flex-shrink-0 items-center">
        <Logo />
      </div>
      <div className="flex flex-1 justify-center px-4 md:px-6 lg:px-8">
        <NavigationMenu>
          <NavigationMenuList className="gap-1 md:gap-2 lg:gap-4 xl:gap-6">
            <NavigationMenuItem>
              <NavigationMenuTrigger
                className={`text-base font-semibold ${isSection('/lenders') ? 'text-[#095678]' : ''}`}
              >
                Lenders
              </NavigationMenuTrigger>
              <NavigationMenuContent>
                <div className="w-[1000px] p-8">
                  <h3 className="mb-6 text-sm font-bold tracking-wider text-gray-800 uppercase">
                    Popular Lenders:
                  </h3>
                  <ul className="grid grid-cols-5 gap-x-16 gap-y-4">
                    {lendersData.map(lender => (
                      <li key={lender.href} className="min-w-0">
                        <NavigationMenuLink asChild>
                          <UtmLink
                            to={lender.href}
                            aria-current={
                              isActive(lender.href) ? 'page' : undefined
                            }
                            className={`inline-block rounded-md px-2 py-1.5 text-sm font-medium whitespace-nowrap transition-colors hover:bg-gray-100 hover:text-[#095678] focus:outline-none focus-visible:rounded-md focus-visible:ring-2 focus-visible:ring-[#095678] ${isActive(lender.href) ? 'font-bold text-[#095678]' : 'text-gray-700'}`}
                          >
                            {lender.title}
                          </UtmLink>
                        </NavigationMenuLink>
                      </li>
                    ))}
                  </ul>
                </div>
              </NavigationMenuContent>
            </NavigationMenuItem>
            <NavigationMenuItem>
              <NavigationMenuTrigger
                className={`text-base font-semibold ${isSection('/vehicles') ? 'text-[#095678]' : ''}`}
              >
                Vehicles
              </NavigationMenuTrigger>
              <NavigationMenuContent>
                <div className="w-[1000px] p-8">
                  <h3 className="mb-6 text-sm font-bold tracking-wider text-gray-800 uppercase">
                    Popular Vehicles:
                  </h3>
                  <ul className="grid grid-cols-5 gap-x-16 gap-y-4">
                    {vehicleMakesData.map(vehicle => (
                      <li key={vehicle.href} className="min-w-0">
                        <NavigationMenuLink asChild>
                          <UtmLink
                            to={vehicle.href}
                            aria-current={
                              isActive(vehicle.href) ? 'page' : undefined
                            }
                            className={`inline-block rounded-md px-2 py-1.5 text-sm font-medium whitespace-nowrap transition-colors hover:bg-gray-100 hover:text-[#095678] focus:outline-none focus-visible:rounded-md focus-visible:ring-2 focus-visible:ring-[#095678] ${isActive(vehicle.href) ? 'font-bold text-[#095678]' : 'text-gray-700'}`}
                          >
                            {vehicle.title}
                          </UtmLink>
                        </NavigationMenuLink>
                      </li>
                    ))}
                  </ul>
                </div>
              </NavigationMenuContent>
            </NavigationMenuItem>
            <NavigationMenuItem>
              <NavigationMenuLink asChild>
                <UtmLink
                  to="/about-us"
                  aria-current={isActive('/about-us') ? 'page' : undefined}
                  className={navLinkClass('/about-us')}
                >
                  About Us
                </UtmLink>
              </NavigationMenuLink>
            </NavigationMenuItem>
            <NavigationMenuItem>
              <NavigationMenuLink asChild>
                <UtmLink
                  to="/contact"
                  aria-current={isActive('/contact') ? 'page' : undefined}
                  className={navLinkClass('/contact')}
                >
                  Contact Us
                </UtmLink>
              </NavigationMenuLink>
            </NavigationMenuItem>
          </NavigationMenuList>
        </NavigationMenu>
      </div>
      <div className="flex flex-shrink-0 items-center">
        <CTAButton text="START YOUR CLAIM NOW" className="h-10 px-5 text-sm" />
      </div>
    </div>
  )
}

export default DesktopHeader
